import React, { useCallback, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import LoginService from "services/login.service";
import { ROLE_DC } from "utils/constants";
import { getLoginRoles } from "utils/login";
import { lStorage } from "utils/storage";
import { getHomePath, getResponseMessage, logout } from "utils/common";
import toaster from "utils/toaster";

const HFNAuth = () => {
  let navigate = useNavigate();
  const loginService = useMemo(() => new LoginService(), []);
  const handleAuth = useCallback((status) => {
    const element = document.querySelector("hfn-auth");
    if (element && element.handleProfileAuthentication) {
      element.handleProfileAuthentication(status);
    }
  }, []);

  const getLoginUser = useCallback(async (srcmToken) => {
    try {
      lStorage.remove("authInfo");
      let roles = {};
      let roleResponse = await loginService.getRoles({ srcmToken });

      if (
        !Array.isArray(roleResponse?.data?.results) ||
        roleResponse.data.results.length === 0
      )
        throw Error("Unable to get roles");
      else {
        const roleList = roleResponse.data.results;
        roles = Object.fromEntries(
          roleList.map((item) => [item.roleName, item.id]),
        );
      }

      let apiResponse = await loginService.getCurrentUser({ srcmToken });

      if (apiResponse && apiResponse.data) {
        if (!apiResponse.data.isError) {
          let user = { ...apiResponse.data, srcmToken };
          const loginUser = getLoginRoles(apiResponse.data);
          if (loginUser.isValidUser && !loginUser.hasMoreRoles) {
            user.roles = roles;
            user.loginUser = loginUser.loginUser;
            user.loginRole = loginUser.loginRole;
            user.loginRoles = loginUser.loginRoles;
            user.hasMoreRoles = loginUser.hasMoreRoles;

            try {
              await loginService.getLoginEnvironment(user);
              await loginService.setLoginEnvironment(user);
            } catch {
              console.log("Something went wrong.");
            }

            lStorage.set("authInfo", user);
            if (
              loginUser.loginRole &&
              loginUser.loginRole.roleName === ROLE_DC
            ) {
              lStorage.set("loginUserRoles", { loginUser, user, roles });
              navigate("/select-role");
            } else {
              navigate(getHomePath());
            }
          } else {
            lStorage.set("loginUserRoles", { loginUser, user, roles });
            navigate("/select-role");
          }
          handleAuth(true);
        } else {
          toaster.error(
            getResponseMessage(apiResponse.data) ||
              "Unable to login. Please contact your administrator.",
          );
          await logout();
        }
      } else {
        await logout();
      }
    } catch {
      console.log("Something went wrong.");
    }
  }, []);

  const getProfile = useCallback(
    async (accessInfo) => {
      try {
        getLoginUser(accessInfo?.access_token);
      } catch (error) {
        handleAuth(false);
      }
    },
    [handleAuth],
  );

  useEffect(() => {
    const hfnAuthInfo = localStorage.getItem("hfnAuthInfo");
    if (hfnAuthInfo) {
      navigate("/select-role");
    }
    import("hfnauth-web/main")?.then(() => {
      document.querySelector("hfn-auth").loginCallback = async (res) => {
        try {
          const accessInfo = res?.data;
          if (!accessInfo?.access_token) {
            handleAuth(false);
            return false;
          }
          await getProfile(accessInfo);
        } catch {
          handleAuth(false);
        }
        return true;
      };
    });
  }, [getProfile, handleAuth]);

  return (
    <>
      <div />
    </>
  );
};

export default HFNAuth;
